import {boundMethod} from "autobind-decorator";
import React from "react";
import {Redirect} from "react-router-dom";

import http from "@/services/http";
import {EServerId} from "../models";

import DeleteButton from "@toolbox/button-like/DeleteButton";

interface IDeleteSopProps {
    id: number;
    project: number;
    owner: string;
    messages: React.RefObject<HTMLDivElement>;

    serverId: EServerId;
}

interface IDeleteSopState {
    isDeleted: boolean;
}

class DeleteSop extends React.PureComponent<IDeleteSopProps, IDeleteSopState> {
    public readonly state: IDeleteSopState = {isDeleted: false};

    public render() {
        const {project} = this.props;

        if (this.state.isDeleted) {
            const url = "/project/" + project;

            return <Redirect to={url} push={true} />;
        }

        return (
            <DeleteButton
                id="delete"
                noAnimation={true}
                onDelete={this.delete}
            />
        );
    }

    @boundMethod
    private async delete() {
        const {serverId, id} = this.props;

        try {
            await http.delete(`/api/${serverId}/sop/${id}`);

            this.setState({isDeleted: true});

            return true;
        } catch {
            return false;
        }
    }
}

export default DeleteSop;
